module.exports = ".dropdown-menu-shrink {\n  padding: 0;\n  width: 4em;\n  min-width: 4em; }\n\n.dropdown-list {\n  width: 100%;\n  margin: 0; }\n\n.dropdown-list li {\n    cursor: pointer; }\n\n.dropdown-list li:hover {\n    background: #eee; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/silk/toolbars/standard-toolbar/font-size-dropdown/font-size-dropdown.component.scss
// module id = ./src/app/shared/components/silk/toolbars/standard-toolbar/font-size-dropdown/font-size-dropdown.component.scss
// module chunks = main